export class PaginationConstants {
  public static DEFAULT_PAGE_SIZE = 10;
  public static PAGE_SIZES = [5, 10, 20, 50];
}
